import type {
  BreadcrumbHandle,
  BreadcrumbItem,
} from "@/types/router-breadcrumb";
import type { AxiosError } from "axios";
import { redirect } from "react-router";

export async function withNotFoundRedirect<T>(
  fn: () => Promise<T>,
  fallbackPath: string,
): Promise<T> {
  try {
    return await fn();
  } catch (e) {
    const error = e as AxiosError<{ message: string }>;
    if (error.isAxiosError && error.response?.status === 404) {
      throw redirect(fallbackPath);
    }
    throw e;
  }
}

export const makeHandle = (...items: BreadcrumbItem[]): BreadcrumbHandle => ({
  breadcrumb: () => items,
});

export type LoaderParams = { params: Record<string, string | undefined> };

type DataNameMatch = { loaderData?: { data?: { name?: string } } };

/**
 * Breadcrumb handle for detail routes whose loader resolves a name: renders the
 * base crumb plus the resolved name, omitting it while it is still unavailable.
 */
export const makeOptionalNameHandle = (base: BreadcrumbItem) => ({
  breadcrumb: (match: DataNameMatch): BreadcrumbItem[] => {
    const crumbs: BreadcrumbItem[] = [base];
    if (match?.loaderData?.data?.name) {
      crumbs.push({ label: match.loaderData.data.name });
    }
    return crumbs;
  },
});
